/**
 * Игровые константы: размеры поля, лимиты, ключи сцен и т.д.
 */

const BASE_GAME_WIDTH = 800;
const DESKTOP_GAME_WIDTH = 1400;
export const GAME_WIDTH =
  typeof window !== 'undefined' && window.innerWidth >= 900
    ? DESKTOP_GAME_WIDTH
    : BASE_GAME_WIDTH;

/** Базовая высота (десктоп). На мобилке увеличиваем по aspect ratio, чтобы канвас заполнял экран и лоток был внизу. */
const BASE_GAME_HEIGHT = 600;
export const GAME_HEIGHT =
  typeof window !== 'undefined' && window.innerWidth > 0
    ? Math.max(BASE_GAME_HEIGHT, Math.ceil((GAME_WIDTH * window.innerHeight) / window.innerWidth))
    : BASE_GAME_HEIGHT;

/** Высота лотка деталей в игровых координатах (снизу экрана). */
export const TRAY_HEIGHT = 160;

/** Радиус слабого снапа к правильной позиции (px). */
export const SNAP_RADIUS = 24;

/** Начиная с этой сложности включаем zoom/pan на доске. */
export const BOARD_VIEWPORT_ZOOM_FROM_DIFFICULTY = 144;

/** Насколько широко вписываем изображение пазла в safe-область (меньше отступы при большем значении). */
export const BOARD_SAFE_FIT_RATIO = 0.98;

/** Дополнительный множитель размера рабочей области доски внутри вписанного изображения. */
export const BOARD_CONTENT_FILL_RATIO = 0.96;

/**
 * Сложности, для которых включены специальные настройки лотка:
 * - hi-res генерация текстур;
 * - адаптивное ограничение размера кусочков.
 */
export const TRAY_TUNED_DIFFICULTIES = [252, 448] as const;

/** Масштаб повышенного разрешения для текстур лотка. */
export const TRAY_HIRES_SCALE = 3;

/**
 * Для каких сложностей использовать "эталон" размера куска от другой сложности.
 * Сейчас: 448 отображаем по эталону 252, чтобы в лотке размер был как у 252.
 */
export const TRAY_SIZE_REFERENCE_BY_DIFFICULTY: Readonly<Record<number, number>> = {
  448: 252,
};

/**
 * Допустимый апскейл фрагмента в ФИЗИЧЕСКИХ пикселях экрана.
 * 4.4 — более крупные куски в лотке для 252/448 (примерно x2 к предыдущему режиму).
 */
export const TRAY_MAX_SOURCE_UPSCALE_PHYSICAL = 5.4;

/** Минимальный размер куска в лотке (CSS px) для high-difficulty режима. */
export const TRAY_MIN_PIECE_CSS_PX = 88;

export const SCENE_KEYS = {
  Boot: 'Boot',
  Preload: 'Preload',
  Hub: 'Hub',
  Puzzle: 'Puzzle',
  Pack: 'Pack',
  PacksList: 'PacksList',
  Collection: 'Collection',
} as const;
